/**
 * Ads Module.
 *
 * Provides some post loading processing of the ads
 *
 * @param data
 */

/**
 * Include the dependencies.
 */
var $ = require('jquery');


/**
 * Makes all ad wrappers containing an ad visible and sizes appropriately
 *
 */

var updateAds = function () {

    // resize ad wrapper based on ad served
    $.each( $('.ad-placeholder').not('.sized'), function( i, val ) {
        $(this).bind("DOMSubtreeModified", function() {
            var wrapper = $(this);
            var ad_iframe = $(this).find('[id^=google_ads_iframe]');
            if ( ad_iframe.length) {
                wrapper.css('height', ad_iframe.innerHeight());
                wrapper.parent().css('display', 'block');
                wrapper.addClass('sized');
                $(window).trigger('irResizedAds');
                $(this).unbind("DOMSubtreeModified");
            }
        });
    });
};

/**
 * Methods to execute immediately.
 */
var init = function () {
    updateAds();
    setTimeout(function(){
        $(".ad-placeholder:empty").parent().hide();
    }, 8000);
};

/**
 * Export all of the methods.
 */
module.exports = {
    init: init,
    updateAds: updateAds
};
